import { CircularProgress as MUICircularProgress } from "@material-ui/core";
import React from "react";
import { LoadingComponentProps } from "react-loadable";

interface IProps extends LoadingComponentProps {
  variant: "inline" | "small" | "medium" | "large" | "xlarge";
}

const variantMap: Record<IProps["variant"], { size: number; thickness: number }> = {
  inline: { size: 12, thickness: 2 },
  small: { size: 40, thickness: 2 },
  medium: { size: 60, thickness: 3 },
  large: { size: 80, thickness: 4 },
  xlarge: { size: 100, thickness: 5 },
};

export class CircularProgress extends React.PureComponent<IProps> {
  public static defaultProps = {
    variant: "medium",
    isLoading: false,
    pastDelay: false,
    timedOut: false,
    error: null,
    retry: () => null,
  };

  render() {
    const { size, thickness } = variantMap[this.props.variant];

    return <MUICircularProgress size={size} thickness={thickness} />;
  }
}
